const $inject = [];

const inputMatch = function () {
  return {
    require: 'ngModel',
    link: function (scope, elem, attrs, ctrl) {
      const firstPassword = '#' + attrs.inputMatch;
      elem.add(firstPassword).on('keyup', function () {
        scope.$apply(function () {
          const v = elem.val()===$(firstPassword).val();
          ctrl.$setValidity('inputMatch', v);
        });
      });
    }
  };
};

inputMatch.$inject = $inject;

export default inputMatch;


// WEBPACK FOOTER //
// ./src/directives/inputMatch.js